import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 320px;

  position: absolute;
  right: -40px;
  bottom: -10px;
  z-index: 1;
  transform: translateY(100%);
`;

export const Content = styled.div`
  width: 100%;
  border-bottom-left-radius: ${props => props.theme.borderRadius.round};
  border-bottom-right-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.colors.white};

  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.black};
  box-shadow: 0px 0px 15px rgba(0, 22, 79, 0.3);
  position: relative;
  z-index: 1;

  padding: 10px 20px;
`;

export const Decoration = styled.div`
  display: block;
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.white};
  position: absolute;
  top: -5px;
  right: 40px;

  z-index: 2;

  transform: rotate(45deg);
`;
